import { EFinancingProgram } from '@if/core/types'
import { CalculateTermPlanOptionsDto, TermPlanOptionDto } from '@src/types/TermPlanOptionDto'
import { keepPreviousData, QueryFunctionContext, useQuery } from '@tanstack/react-query'
import { getApiClient } from '../api-client'

const SCOPE = 'termPlanOptions'

const keysFactory = {
  termAndPlanOptions: (dto: CalculateTermPlanOptionsDto) => [{ scope: SCOPE, ...dto }] as const,
}

const calculateTermAndPlanOptions = async ({
  queryKey: [dto],
}: QueryFunctionContext<ReturnType<(typeof keysFactory)['termAndPlanOptions']>>): Promise<TermPlanOptionDto[]> => {
  const apiClient = getApiClient()
  const response = await apiClient.post<TermPlanOptionDto[]>(
    `Worksheet/${EFinancingProgram.Personal}/CalculateTermAndPlanOptions`,
    dto,
  )
  return response.data
}

export function useCalculateTermAndPlanOptions(
  dto: CalculateTermPlanOptionsDto | null,
): [TermPlanOptionDto[] | null, boolean] {
  const { data, isFetching } = useQuery({
    queryKey: keysFactory.termAndPlanOptions(dto!),
    queryFn: calculateTermAndPlanOptions,
    enabled: dto !== null,
    // Every input that feeds the request is part of the key — toggling the protection
    // plan included. Without this the rows blank out on each change and the table
    // flashes back to skeletons; keeping the previous ones lets the values update in
    // place. Same treatment the funding compute already gets.
    placeholderData: keepPreviousData,
  })

  return [data ?? null, isFetching]
}
